<div *ngIf="isLoading" class="loading-overlay">
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
</div>
<div *ngIf="!isLoading" class="ec-interview-response">
  <img
    src="https://res.cloudinary.com/dichgutd0/image/upload/v1723631419/EL-Core-Assets/Static/Career/d096c9354b3f6e81b8c8ad8774e897ac_dzm8ny.webp"
    alt="email-frame"
    class="email-frame mx-auto"
  />

  <div class="main-container" [formGroup]="technicalInterviewForm">
    <div class="text-center mx-auto title">
      <h2 class="main-container-title">
        <ng-container *ngIf="isHrInterview; else technicalInterview">
          {{
            'static.components.technical-interview-component.hr-title'
              | translate
          }}
        </ng-container>
        <ng-template #technicalInterview>
          {{
            'static.components.technical-interview-component.title' | translate
          }}
        </ng-template>
      </h2>
    </div>
    <div class="custom-radio-group mt-3 mx-auto">
      <input
        type="radio"
        class="btn-check"
        name="btnradio"
        id="btnradio_1"
        autocomplete="off"
        (click)="setAttendance(INTERVIEW_ATTENDANCE.YES)"
        (click)="onSubmit()"
      />
      <label class="btn yes" for="btnradio_1">{{
        INTERVIEW_ATTENDANCE.YES
      }}</label>

      <input
        type="radio"
        class="btn-check"
        name="btnradio"
        id="btnradio_2"
        autocomplete="off"
        (click)="setAttendance(INTERVIEW_ATTENDANCE.NO)"
        (click)="onSubmit()"
      />
      <label class="btn no" for="btnradio_2">{{
        INTERVIEW_ATTENDANCE.NO
      }}</label>

      <input
        type="radio"
        class="btn-check"
        name="btnradio"
        id="btnradio_3"
        autocomplete="off"
        (click)="setAttendance(INTERVIEW_ATTENDANCE.RESCHEDULE)"
      />
      <label class="btn reschedule" for="btnradio_3">{{
        INTERVIEW_ATTENDANCE.RESCHEDULE
      }}</label>
    </div>

    <div class="reschedule-fields">
      <mat-form-field
        appearance="fill"
        class="reason-field"
        *ngIf="isToggleRescheduleFields"
        class="reason-field mt-5"
      >
        <mat-label>{{
          'static.components.technical-interview-component.reason' | translate
        }}</mat-label>
        <mat-select
          id="technical_interview_reschedule_dropdown"
          class="mx-auto"
          formControlName="rescheduleReason"
          [required]="isToggleRescheduleFields"
        >
          <mat-option
            *ngFor="let rescheduleReason of rescheduleReasonsArray"
            id="technical_interview_reschedule_option{{
              rescheduleReason.key.toString()
            }}"
            [value]="rescheduleReason.key"
            >{{ rescheduleReason.value }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            technicalInterviewForm.get('rescheduleReason').hasError('required')
          "
          >{{
            'static.components.technical-interview-component.reschedule-reason-required'
              | translate
          }}</mat-error
        >
      </mat-form-field>

      <mat-form-field
        appearance="fill"
        class="describe-field"
        *ngIf="isToggleRescheduleFields"
      >
        <mat-label>{{
          'static.components.technical-interview-component.describe' | translate
        }}</mat-label>
        <input
          matInput
          formControlName="rescheduleDescription"
          [required]="isToggleRescheduleFields"
          class="custom-input"
        />
        <mat-error
          *ngIf="
            technicalInterviewForm
              .get('rescheduleDescription')
              .hasError('required')
          "
        >
          {{
            'static.components.technical-interview-component.reschedule-describe-required'
              | translate
          }}
        </mat-error>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        class="reschedule-submit mb-2"
        *ngIf="isToggleRescheduleFields"
        (click)="onSubmit()"
        [disabled]="!technicalInterviewForm.valid"
      >
        {{
          'static.components.technical-interview-component.submit' | translate
        }}
      </button>
    </div>
  </div>
  <div class="email-frame mx-auto footer">
    <tr>
      <td
        style="
          padding: 50px 100px 40px 100px;
          background-color: #e2e2e2;
          text-align: center;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        "
      >
        <p
          style="
            margin: 0 0 16px 0;
            font-size: 12px;
            font-weight: 400;
            font-family: 'Manrope', sans-serif;
            color: #828282;
            line-height: 20px;
          "
        >
          EchonLabs is an IT startup based in UK and Sri Lanka. Our passionate
          team of engineers, designers, and innovators is driven by customer
          satisfaction, propelling us to make a meaningful impact on the world.
        </p>
        <div style="margin: 20px 0">
          <a
            href="tel:+94117108040"
            style="text-decoration: none; margin: 0 10px"
          >
            <img
              src="https://res.cloudinary.com/dichgutd0/image/upload/v1724645310/EL-Core-Assets/Static/email_footer/Phone-2_pixed5.png"
              alt="Contact"
              style="width: 24px"
            />
          </a>
          <a
            href="https://www.echonlabs.com"
            style="text-decoration: none; margin: 0 10px"
          >
            <img
              src="https://res.cloudinary.com/dichgutd0/image/upload/v1724645310/EL-Core-Assets/Static/email_footer/GlobeHemisphereWest-1_ysjd9y.png"
              alt="Website"
              style="width: 24px"
            />
          </a>
          <a
            href="https://www.linkedin.com/company/echonlabs"
            style="text-decoration: none; margin: 0 10px"
          >
            <img
              src="https://res.cloudinary.com/dichgutd0/image/upload/v1724645310/EL-Core-Assets/Static/email_footer/LinkedinLogo-1_ioctsp.png"
              alt="LinkedIn"
              style="width: 24px"
            />
          </a>
          <a
            href="https://www.facebook.com/echonlabs"
            style="text-decoration: none; margin: 0 10px"
          >
            <img
              src="https://res.cloudinary.com/dichgutd0/image/upload/v1724645310/EL-Core-Assets/Static/email_footer/FacebookLogo-1_x16zw3.png"
              alt="Facebook"
              style="width: 24px"
            />
          </a>
        </div>
      </td>
    </tr>
  </div>
</div>
